import React, { useState, useEffect } from "react";
import Pagador from "./Pagador";

import {
  FormControlLabel, Grid2, MenuItem, Switch, TextField,
  Button, TableCell, TableRow, TableContainer, InputAdornment,
  Table, TableHead, TableBody, Box
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { setCargaGeneral } from "../Redux/GeneralDuck";
import ShowInformation from "./subs/ShowInformation";
import Swal from "sweetalert2";
import { setCargaDatos } from "../Redux/V2/ContratoRedux";
import { WidthNormal } from "@mui/icons-material";
import AddIcon from '@mui/icons-material/Add'
import { SkipNext } from '@mui/icons-material';

const formatter = new Intl.NumberFormat("es-CL");

const Cuotas = ({ from, onChangeSave }) => {
  const dispatch = useDispatch();

  const entrevista = useSelector((store) => store.contratoV2.Entrevista);
  const contrato = useSelector((store) => store.contratoV2.contrato);
  const cuotas = useSelector((store) => store.contratoV2.Cuotas);
  const metodosPago = useSelector((store) => store.general.metodosPago);
  const pagador = useSelector((store) => store.contratoV2.Pagador);
  const actualizacion = useSelector((store) => store.contratoV2.Actualizacion);

  // 🔒 estados para bloqueo total de UI
  const contratoCancelado = useSelector((s) => s.contratoV2.ContratoCancelado);
  const contratoFiniquitado = useSelector((s) => s.contratoV2.ContratoFiniquitado);
  const contratoFirmado = useSelector((s) => s.contratoV2.ContratoFirmado);

  const [contratoView, setContratoView] = useState([])

  const [disabledComponent, setDisabledComponent] = useState(false);


  const bloqueadoTotalmente =
    !!contratoCancelado?.cancelado ||
    !!contratoFiniquitado?.finiquitado || (contratoFirmado?.firmado && !disabledComponent)

  const [planPago, setPlanPago] = useState({})

  const metodoId = Number(planPago.metodoPagoId ?? 6);

  const cuotasInvalidasUI =
    metodoId === 6
      ? !(Number(planPago.numCuotas) > 1)   // método 6 => > 1
      : !(Number(planPago.numCuotas) >= 1); // otros => >= 1


  //const isPendiente = contratoFirmado?.pendiente == 3 ? true : false; 

  const [payingCustomer, setPayingCustomer] = useState({
    idCountry: "",
    idRegion: "",
    idProvince: "",
    idDistrito: "",
    firstName: "",
    lastName: "",
    identifier: "",
    email: "",
    telephone: "",
    address: "",
    // observations: "",
    idEstadoCivil: "",
    idGenero: "",
    clientType: "",
    pymeRut: "",
    pymeName: "",
    ocupacion: ""
  });

  useEffect(() => {
    if (actualizacion?.actualizacion?.status == 1) { //actualizacion en curso, cargar el defendido de la actualizacion
      setDisabledComponent(true)
      if (actualizacion.actualizacionModelos && actualizacion.actualizacionModelos.length > 0) {
        const _objAct = actualizacion.actualizacionModelos.find(obj => obj.model == "pagador");
        if (_objAct != null) {
          setPayingCustomer(JSON.parse(_objAct.json)/*.servicios*/);
          return
        }
      }
    }
    // si no es actualizacion, o no hay pagador en la actualizacion, cargar el pagador normal
    if (pagador?.identifier == null && entrevista.payingCustomerId != null) {
      dispatch(setCargaDatos("Pagador", "get", entrevista.id))
    } else if (pagador?.identifier != null) {
      setPayingCustomer(pagador)
      console.log(pagador)
    }
  }, [pagador])

  useEffect(() => {
    dispatch(setCargaGeneral("metodosPago"));
    dispatch(setCargaDatos("Cuotas", "get", entrevista.id));
    if (entrevista?.contractId != null && (contrato == null || contrato == undefined || contrato.length == 0)) {
      dispatch(setCargaDatos("contrato", "get", entrevista.contractId));
    }
  }, [entrevista]);

  useEffect(() => {
    if (actualizacion?.actualizacion?.status == 1) { //actualizacion en curso, cargar el defendido de la actualizacion
      if (actualizacion.actualizacionModelos && actualizacion.actualizacionModelos.length > 0) {
        const _objAct = actualizacion.actualizacionModelos.find(obj => obj.model == "servicio");
        if (_objAct != null) {
          var aux = JSON.parse(_objAct.json)
          setContratoView(aux.servicios)
          return
        }
      }
    }
    setContratoView(contrato)
  }, [contrato, actualizacion])

  useEffect(() => {
    if (actualizacion?.actualizacion?.status == 1) { //actualizacion en curso, cargar el defendido de la actualizacion
      if (actualizacion.actualizacionModelos && actualizacion.actualizacionModelos.length > 0) {
        const _objAct = actualizacion.actualizacionModelos.find(obj => obj.model == "voucher");
        if (_objAct != null) {
          setPlanPago(JSON.parse(_objAct.json)/*.servicios*/);
          return
        }
      }
    }
    // si no es actualizacion, o no hay cuotas en la actualizacion, cargar el cuotas normal
    if (pagador?.identifier == null && entrevista.payingCustomerId != null) {
      dispatch(setCargaDatos("Pagador", "get", entrevista.id))
    } else if (pagador?.identifier != null) {
      setPlanPago(pagador)
    }

    if (cuotas && cuotas.interviewId) //existe
      setPlanPago(cuotas);
  }, [cuotas]);

  const handlePlanPago = (key, value) => {
    if (bloqueadoTotalmente) return;

    if (key === "pie") {
      agregarCuotaPie(value);
      return
    }

    if (key === "metodoPagoId") {
      const val = Number(value);
      setPlanPago(prev => {
        const num = Number(prev.numCuotas) || 0;
        // Entrando a método 6 => mínimo 2 cuotas (sin alerta)
        if (val === 6 && num <= 1) {
          return { ...prev, metodoPagoId: val, numCuotas: 2 };
        }
        return { ...prev, metodoPagoId: val };
      });
      return;
    }

    setPlanPago(prev => ({ ...prev, [key]: value }));
  };



  const calcularCuotas = (auxPie) => {
    if (bloqueadoTotalmente) return; // 🔒
    const aux = auxPie != null ? auxPie : { ...planPago };
    if (!aux.metodoPagoId) aux.metodoPagoId = 6;
    if (!aux.fechaPago) {
      Swal.fire("Faltan datos", "Fecha primer pago obligatorio.", "warning");
      return;
    }
    if (
      entrevista.lineaNegocioId === 4 &&
      (!aux.pLaboral || aux.pLaboral < 1)
    ) {
      Swal.fire(
        "Faltan datos",
        "Porcentaje de Defensa Laboral es obligatorio.",
        "warning"
      );
      return;
    }
    if (!aux.numCuotas || aux.numCuotas < 1) {
      Swal.fire("Faltan datos", "Cantidad de cuotas es obligatorio.", "warning");
      return;
    }

    if (aux.fechaPago == null || aux.fechaPago == undefined) {
      Swal.fire("Fecha de pago", "La fecha de primer pago es obligatoria", "warning");
      return
    }

    const fecha = parseFechaLocal(aux.fechaPago);
    const hoy = new Date();

    hoy.setHours(0, 0, 0, 0);
    fecha.setHours(0, 0, 0, 0);


    if (fecha < hoy) {
      Swal.fire("Fecha de pago", "Cambie la fecha de pago. Es menor a la fecha actual.", "warning");
      return
    }

    const cuotaInicial = calcularMontoCuota(aux.numCuotas);
    aux.cuotas = generarCuotas(aux, cuotaInicial);
    setPlanPago(aux);
  };

  const calcularMontoCuota = (numCuotas) => {
    const total = contratoView.reduce(
      (s, item) => s + (Number(item.monto) || 0),
      0
    );
    return Math.floor(total / numCuotas);
  };


  // ===== Helpers de fecha (ponlos arriba en el archivo o antes de generarCuotas)
  const pad2 = (n) => String(n).padStart(2, '0');

  const parseYMD = (s) => {
    const [y, m, d] = s.split('-').map(Number);
    return { y, m, d };
  };

  const lastDayOfMonth = (y, m /* 1-12 */) => {
    // Día 0 del siguiente mes = último día del mes m
    return new Date(Date.UTC(y, m, 0)).getUTCDate();
  };

  const addMonthsClamped = ({ y, m, d }, delta) => {
    // m es 1-12 internamente usamos índice 0-11
    const mIdx = m - 1 + delta;
    const y2 = y + Math.floor(mIdx / 12);
    const m2Idx = ((mIdx % 12) + 12) % 12; // 0-11
    const m2 = m2Idx + 1; // 1-12
    const dMax = lastDayOfMonth(y2, m2);
    const d2 = Math.min(d, dMax);
    return { y: y2, m: m2, d: d2 };
  };

  const toYMD = ({ y, m, d }) => `${y}-${pad2(m)}-${pad2(d)}`;

  // ===== Reemplaza tu generarCuotas por esta
  const generarCuotas = (aux, cuotaInicial) => {
    // Trabajamos en YMD para evitar problemas de zona horaria
    const hoy = new Date();
    const todayYMD = `${hoy.getFullYear()}-${pad2(hoy.getMonth() + 1)}-${pad2(hoy.getDate())}`;

    const start = parseYMD(aux.fechaPago);
    const cuotas = [];

    if (aux.pie) {
      // La cuota 0 (pie) queda hoy si la fecha de pago es anterior a hoy
      const pieDate = (aux.fechaPago >= todayYMD) ? aux.fechaPago : todayYMD;
      cuotas.push({ id: 0, monto: 0, fecha: pieDate });
    }

    for (let i = 0; i < aux.numCuotas; i++) {
      const d = addMonthsClamped(start, i);   // <-- suma meses con clamp a fin de mes
      let fecha = toYMD(d);
      if (fecha < todayYMD) fecha = todayYMD; // mantiene tu regla de no antes de hoy
      cuotas.push({
        id: i + 1,
        fecha,
        monto: cuotaInicial,
      });
    }

    return cuotas;
  };

  const agregarCuotaPie = (conPie) => {
    let aux = { ...planPago };
    if (!aux.cuotas) aux.cuotas = [];

    if (conPie) {
      const cuota0Index = aux.cuotas.findIndex((c) => c.id === 0);
      if (cuota0Index === -1) {
        aux.cuotas = [
          {
            id: 0,
            monto: 0,
            fecha: aux.fechaPago || new Date().toISOString().split("T")[0],
          },
          ...aux.cuotas,
        ];
      } else {
        aux.cuotas[cuota0Index].monto = 0;
      }
      aux.pie = conPie;
      setPlanPago(aux)
    } else {
      aux.cuotas = aux.cuotas.filter((c) => c.id !== 0);
      aux.pie = conPie;
      //setPlanPago(aux)
      calcularCuotas(aux)
    }
  };

  const cambiarMontoCuota = (newMonto, cuotaId) => {
    if (bloqueadoTotalmente) return; // 🔒
    let aux = { ...planPago };
    const total = contratoView.reduce(
      (s, item) => s + (Number(item.monto) || 0),
      0
    );

    let montoPrevio = 0;
    aux.cuotas = aux.cuotas.map((item) => {
      if (item.id > 0 && item.id < cuotaId) montoPrevio += item.monto;
      if (item.id === cuotaId) {
        montoPrevio += newMonto;
        return { ...item, monto: newMonto };
      }
      if (item.id > cuotaId && item.id > 0) return { ...item, monto: 0 };
      return item;
    });

    const countNegativos = aux.cuotas.filter(
      (c) => c.id > 0 && c.monto === 0
    ).length;
    const montoCuotasSiguiente = Math.floor(
      (total - montoPrevio) / countNegativos
    );

    aux.cuotas = aux.cuotas.map((item) => {
      if (item.id > 0 && item.monto === 0)
        return {
          ...item,
          monto: montoCuotasSiguiente < 0 ? 0 : montoCuotasSiguiente,
        };
      return item;
    });

    setPlanPago(aux);
  };

  const handleNumCuotasChange = (e) => {
    if (bloqueadoTotalmente) return;

    const soloNumeros = e.target.value.replace(/\D/g, "");
    const valorCuotas = soloNumeros ? Number(soloNumeros) : 0;

    // Tope general
    const topeMax = contratoView.reduce((max, item) => Math.max(max, item.maxCuota), 0);

    if (valorCuotas > 72) {
      Swal.fire({ title: "Cantidad inválida", text: "Las cuotas no pueden ser mayores a 72", icon: "error" });
      return;
    }

    if (valorCuotas > topeMax && valorCuotas <= 72) {
      Swal.fire({
        title: "Confirmación requerida",
        text: `La cantidad de cuotas (${valorCuotas}) excede el tope permitido (${topeMax}). ¿Desea continuar?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, continuar",
        cancelButtonText: "No, corregir",
      }).then((result) => {
        if (result.isConfirmed) handlePlanPago("numCuotas", valorCuotas);
      });
      return;
    }

    handlePlanPago("numCuotas", valorCuotas);
  };

  const parseFechaLocal = (yyyyMMdd) => {
    const [year, month, day] = yyyyMMdd.split("-").map(Number);
    return new Date(year, month - 1, day); // ← esto usa hora local
  }

  const validarPagador = (pagador) => {
    const errores = {};

    // Campos obligatorios básicos
    if (!pagador.idCountry) errores.idCountry = "País es obligatorio";
    if (!pagador.idRegion) errores.idRegion = "Región es obligatoria";
    if (!pagador.idProvince) errores.idProvince = "Provincia es obligatoria";
    if (!pagador.idDistrito) errores.idDistrito = "Comuna es obligatoria";

    if (!pagador.firstName) errores.firstName = "Nombre es obligatorio";
    if (!pagador.lastName) errores.lastName = "Apellido es obligatorio";
    if (!pagador.identifier) errores.identifier = "Rut es obligatorio";

    if (!pagador.email) {
      errores.email = "Email es obligatorio";
    } else {
      // Regex básica para validar formato de email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(pagador.email)) {
        errores.email = "Formato de email no válido";
      }
    }

    if (!pagador.telephone) errores.telephone = "Teléfono es obligatorio";

    // Dirección con validación de largo
    if (!pagador.address) {
      errores.address = "Dirección es obligatoria";
    } else if (pagador.address.length > 100) {
      errores.address = "La dirección no puede superar 100 caracteres";
    }

    // if (!pagador.observations) errores.observations = "Observaciones son obligatorias";

    // Datos adicionales
    if (!pagador.idEstadoCivil) errores.idEstadoCivil = "Estado civil es obligatorio";
    if (!pagador.idGenero) errores.idGenero = "Género es obligatorio";
    if (pagador.clientType == null || pagador.clientType == undefined) errores.clientType = "Tipo de cliente es obligatorio";

    // Validaciones extra si es cliente jurídico
    if (pagador.clientType === 2) { // Cliente jurídico
      if (!pagador.pymeRut) errores.pymeRut = "Rut empresa es obligatorio";
      if (!pagador.pymeName) errores.pymeName = "Nombre empresa es obligatorio";
    }

    if (!pagador.ocupacion) errores.ocupacion = "Ocupación es obligatoria";

    return errores;
  };

  const handleSubmit = async () => {
    if (bloqueadoTotalmente) return; // 🔒

    // --- Regla: si método de pago = 6, exigir al menos 2 cuotas ---
    const metodo = Number(planPago.metodoPagoId ?? 6);
    const numCuotasInput = Number(planPago.numCuotas) || 0;
    if (metodo === 6 && numCuotasInput <= 1) {
      Swal.fire({
        icon: "warning",
        title: "Validación",
        text: "Para el método de pago seleccionado debe ingresar al menos 2 cuotas.",
      });
      return;
    }

    // --- Validar que lo dibujado coincida con el input (ignorar PIE id=0) ---
    const cuotasRealesGeneradas = Array.isArray(planPago.cuotas)
      ? planPago.cuotas.filter(c => c.id > 0).length
      : 0;

    if (!numCuotasInput || cuotasRealesGeneradas !== numCuotasInput) {
      Swal.fire({
        icon: "warning",
        title: "Cuotas no coinciden",
        text: `Ingresó ${numCuotasInput} cuotas, pero se han generado ${cuotasRealesGeneradas}. Presione "Calcular" para regenerar las cuotas.`,
      });
      return;
    }

    const errores = validarPagador(payingCustomer);
    if (Object.keys(errores).length > 0) {
      Swal.fire({
        title: "Errores en los datos del pagador",
        html: Object.values(errores).map(e => `<p>${e}</p>`).join(""),
        icon: "error"
      });
      return;
    }

    if (!planPago.cuotas || planPago.cuotas.length === 0) {
      Swal.fire("Error", "No hay cuotas para guardar", "warning");
      return;
    }

    // Validación
    const fecha = parseFechaLocal(planPago.fechaPago);
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    fecha.setHours(0, 0, 0, 0);
    if (fecha < hoy) {
      Swal.fire("Fecha de pago", "Cambie la fecha de pago. Es menor a la fecha actual.", "warning");
      return
    }
    

    for (let i = 0; i < planPago.cuotas.length; i++) {
      const cuota = planPago.cuotas[i];
      const [y, m, d] = cuota.fecha.split("-").map(Number);
      const fecha = new Date(y, m - 1, d);
      const hoy = new Date();
      hoy.setHours(0, 0, 0, 0);

      if (fecha < hoy) {
        Swal.fire(
          "Error",
          `La fecha de la cuota ${cuota.id} es menor a hoy`,
          "warning"
        );
        return;
      }

      if (i > 0) {
        const [py, pm, pd] = planPago.cuotas[i - 1].fecha
          .split("-")
          .map(Number);
        const fechaPrev = new Date(py, pm - 1, pd);
        if (fecha < fechaPrev) {
          Swal.fire(
            "Error",
            `La fecha de la cuota ${cuota.id == 0 ? "Pie" : cuota.id} 
             no puede ser menor a la cuota anterior (${planPago.cuotas[i - 1].fecha
            })`,
            "warning"
          );
          return;
        }
      }
      if ((!cuota.monto || cuota.monto <= 0) && contratoView.reduce((suma, emp) => suma + emp.monto, 0)) {
        Swal.fire(
          "Error",
          `El monto de la cuota ${cuota.id == 0 ? "Pie" : cuota.id} es inválido.`,
          "warning"
        );
        return;
      }
    }

    var totalServicios = contratoView.reduce((suma, emp) => suma + emp.monto, 0)
    var totalPlan = planPago.cuotas.reduce((suma, emp) => suma + emp.monto, 0)

    if (totalPlan > totalServicios) {
      Swal.fire(
        "Error",
        `El monto del plan es mayor a los servicios contratados`,
        "warning"
      );
      return
    }

    const payload = {
      interviewId: entrevista.id,
      numCuotas: planPago.numCuotas,
      fechaPago: planPago.fechaPago,
      metodoPagoId: planPago.metodoPagoId,
      aprobado: true,
      pie: planPago.pie ?? false,
      laborPercentage: planPago.pLaboral ?? 0,
      cuotas: planPago.cuotas.map((c) => ({
        id: c.id,
        fecha: c.fecha,
        monto: c.monto,
      })),
    };

    if (actualizacion?.actualizacion?.status == 1) { //si es actualizacion en curso
      var payloadCuotas = {
        json: JSON.stringify(payload),
        model: "voucher",
        actualizacionId: actualizacion.actualizacion.id,
      }
      var exitoCuotas = await dispatch(setCargaDatos("Actualizacion", "put", payloadCuotas));
      onChangeSave(from)
      return
    }

    var auxPagador = { ...payingCustomer };
    auxPagador.interviewId = entrevista.id;
    var exitoPagador = await dispatch(setCargaDatos("Pagador", "post", auxPagador));

    if (exitoPagador) {
      var exito = await dispatch(setCargaDatos("Cuotas", "post", payload));

      if (exito) {
        if (entrevista.etapaId > from) {
          onChangeSave(from);
          return
        }
        await dispatch(setCargaDatos("Entrevista", "get", entrevista.id))
      }
    }

  };

  const isPendingApproval = planPago.aprobado === false;


  const updateMetodoPago = async () => {
    if (actualizacion?.actualizacion?.status == 1 && actualizacion?.actualizacion?.type == 2) { //si es actualizacion en curso
      var payloadCuotas = {
        json: JSON.stringify({ metodoPagoId: planPago.metodoPagoId }),
        model: "metodoPago",
        actualizacionId: actualizacion.actualizacion.id,
      }
      var exitoCuotas = await dispatch(setCargaDatos("Actualizacion", "put", payloadCuotas))
    }

  }

  return (
    <div style={{ padding: "20px" }}>
      <ShowInformation from={from} />
      <Pagador
        payingCustomer={payingCustomer}
        setPayingCustomer={setPayingCustomer}
        bloquearRut={disabledComponent || bloqueadoTotalmente} // 🔒 pasar bloqueo combinado
      />

      <Grid2 container sx={{ pl: 3, pr: 3, pt: 0 }}>
        {/* Tabla de Contrato */}
        <Grid2 size={12}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Servicio</TableCell>
                  <TableCell style={{ textAlign: "center", paddingLeft: "30px" }}>Costo Servicio</TableCell>
                  <TableCell align="right">Tope de Cuotas</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {contratoView?.map((row, ii) => (
                  <TableRow key={ii}>
                    <TableCell>{row.name}</TableCell>
                    <TableCell style={{ textAlign: "center" }} >
                      $ {row.monto ? formatter.format(row.monto) : ""}
                    </TableCell>
                    <TableCell style={{ textAlign: "right", paddingRight: "60px" }}>{row.maxCuota}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid2>


        <Grid2 size={12} sx={{ mt: 2, mb: 1 }}>
          {/* separador sin línea */}
          <Box sx={{ height: 12 }} />
        </Grid2>



        {/* Formulario de Plan Pago */}
        <Grid2 size={12} container columnSpacing={2} rowSpacing={2} alignItems="center" sx={{ mb: 3 }}>
          <Grid2 size={4}>
            <TextField
              select
              label="Método de Pago"
              fullWidth
              value={planPago.metodoPagoId ?? 6}
              onChange={(e) => handlePlanPago("metodoPagoId", e.target.value)}
              disabled={bloqueadoTotalmente} // 🔒
            >
              {metodosPago?.map((obj) => (
                <MenuItem key={obj.id} value={Number(obj.id)}>
                  {obj.name}
                </MenuItem>
              ))}
            </TextField>

          </Grid2>



          <Grid2 size={3}>
            <TextField
              fullWidth
              label="Fecha Primer Pago"
              type="date"
              value={planPago.fechaPago || ""}
              onChange={(e) => handlePlanPago("fechaPago", e.target.value)}
              InputLabelProps={{ shrink: true }}
              inputProps={{
                min: new Date().toISOString().split("T")[0], // bloquea fechas anteriores a hoy
              }}
              disabled={bloqueadoTotalmente} // 🔒
            />
          </Grid2>

          <Grid2 size={1}>
            <TextField
              fullWidth
              label="N° de Cuotas"
              name="numCuotas"
              value={planPago.numCuotas ? Number(planPago.numCuotas) : null}
              onChange={handleNumCuotasChange}
              InputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
              InputLabelProps={{ shrink: true }} // 👈 mantiene el label arriba error={planPago.numCuotas < 1 || isNaN(planPago.numCuotas)} 
              helperText={planPago.numCuotas < 1 || isNaN(planPago.numCuotas) ? "Cuotas menor a las permitidas" : ""} disabled={bloqueadoTotalmente} // 🔒
            />
          </Grid2>

          {entrevista?.lineaNegocioId === 4 && (
            <Grid2 size={2}>
              <TextField
                fullWidth
                label="% Laboral"
                value={planPago.pLaboral ?? ""}
                onChange={(e) =>
                  handlePlanPago("pLaboral", Number(e.target.value))
                }
                type="number"
                disabled={bloqueadoTotalmente} // 🔒
              />
            </Grid2>
          )}

          <Grid2 size={2} sx={{ display: "flex", alignItems: "center" }}>
            <Button onClick={() => calcularCuotas(null)} variant="outlined" disabled={bloqueadoTotalmente}/* 🔒 */>
              Calcular
            </Button>
          </Grid2>
          {(actualizacion?.actualizacion?.status == 1 /*&& actualizacion?.actualizacion?.type == 1*/) ?
            <Grid2 size={12} sx={{ display: "flex", alignItems: "left" }}>
              <Button variant='outlined' onClick={updateMetodoPago}>Actualizar Solo Metodo de Pago</Button>
            </Grid2>
            : null}

        </Grid2>

        <Grid2 sx={{ mb: 3, mr: 1 }} size={6}>
          {(planPago?.cuotas && planPago?.cuotas.length > 0) && (
            <FormControlLabel
              control={
                <Switch
                  checked={planPago.pie ?? false}
                  onChange={(e) => handlePlanPago("pie", e.target.checked)}
                  disabled={bloqueadoTotalmente} // 🔒
                />
              }
              label={planPago.pie ? "Quitar Pie" : "Incluir Pie"}
            />
          )}

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: "90px", textAlign: "center" }}>N° Cuota</TableCell>
                  <TableCell sx={{ width: "100px", textAlign: "center" }}>Fecha</TableCell>
                  <TableCell sx={{ width: "150px", textAlign: "center" }}>Monto</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {planPago?.cuotas?.map((row, ii) => (
                  <TableRow key={ii}>
                    <TableCell sx={{ width: "90px", textAlign: "center" }}> {row.id == 0 ? "pie" : row.id ?? ""}</TableCell>
                    <TableCell align="center">
                      <TextField
                        type="date"
                        value={row.fecha || ""}
                        onChange={(e) => {
                          if (bloqueadoTotalmente) return; // 🔒
                          const nuevaFecha = e.target.value;
                          setPlanPago((prev) => ({
                            ...prev,
                            cuotas: prev.cuotas.map((c) =>
                              c.id === row.id ? { ...c, fecha: nuevaFecha } : c
                            ),
                          }));
                        }}
                        InputLabelProps={{ shrink: true }}
                        disabled={bloqueadoTotalmente} // 🔒
                      />
                    </TableCell>
                    <TableCell align="right">
                      <TextField
                        value={
                          row.monto !== null && row.monto !== undefined
                            ? new Intl.NumberFormat("es-CL").format(row.monto)
                            : ""
                        }
                        onChange={(e) =>
                          cambiarMontoCuota(Number(e.target.value.replace(/\D/g, "")), row.id)
                        }
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                          inputMode: "numeric",
                          readOnly: bloqueadoTotalmente, // 🔒
                        }}
                        disabled={bloqueadoTotalmente} // 🔒
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid2>
      </Grid2>

      {/* Botón Guardar Cuotas */}
      <Grid2 size={12} sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', pr: 3 }}>

        {bloqueadoTotalmente ? (
          <Button
            type="button"
            variant="contained"
            color="success"
            startIcon={<SkipNext />}
            size="large"
            onClick={() => onChangeSave(3)}
          >
            Continuar
          </Button>
        ) : (
          <Button
            onClick={handleSubmit}
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            disabled={isPendingApproval} // 🔒
          >
            {isPendingApproval ? "Pendiente de Aprobación" : "GUARDAR Y CONTINUAR"}
          </Button>
        )}

        {isPendingApproval && (
          <p style={{ color: "orange", fontSize: "0.8rem" }}>
            No se puede modificar hasta que sea aprobado.
          </p>
        )}
      </Grid2>


    </div>
  );


};

export default Cuotas;